import Cookies from 'js-cookie';
import { Api } from './index';

export const CreateAdmin = async (body: unknown) => {
	Api.defaults.headers['Authorization'] = `Bearer  ${Cookies.get('access')}`;
	const result = await Api.post('/auth/create/admin/', body)
		.then(response => {
			return response;
		})
		.catch(e => {
			return e.response;
		});

	return result;
};

export const CreateUser = async (body: unknown) => {
	Api.defaults.headers['Authorization'] = `Bearer  ${Cookies.get('access')}`;
	const result = await Api.post('/auth/create/user/', body)
		.then(response => {
			return response;
		})
		.catch(e => {
			return e.response;
		});

	return result;
};

export const EditClientUser = async (body: any) => {
	Api.defaults.headers['Authorization'] = `Bearer  ${Cookies.get('access')}`;
	const userId = body.userId;
	delete body.userId;
	const result = await Api.put('/auth/edit/user/' + userId, body)
		.then(response => {
			return response;
		})
		.catch(e => {
			return e.response;
		});
	return result;
};

export const EditAdminUser = async (body: any) => {
	Api.defaults.headers['Authorization'] = `Bearer  ${Cookies.get('access')}`;
	const userId = body.userId;
	delete body.userId;
	const result = await Api.put('/auth/edit/admin/' + userId, body)
		.then(response => {
			return response;
		})
		.catch(e => {
			return e.response;
		});
	return result;
};

export const GetClientAdmins = async () => {
	Api.defaults.headers['Authorization'] = `Bearer  ${Cookies.get('access')}`;
	if (Cookies.get('type') === 'admin') {
		const result = await Api.get('/auth/get-client-admin')
			.then(response => {
				return response;
			})
			.catch(e => {
				return e.response;
			});

		return result;
	}
	return false;
};

export const GetClientUsers = async () => {
	Api.defaults.headers['Authorization'] = `Bearer  ${Cookies.get('access')}`;
	if (Cookies.get('type') === 'admin') {
		const result = await Api.get('/auth/get-client-user')
			.then(response => {
				return response;
			})
			.catch(e => {
				return e.response;
			});

		return result;
	}
	return false;
};
